'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvEqualizer = function AvEqualizer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z' })
  );
};
AvEqualizer = (0, _pure2.default)(AvEqualizer);
AvEqualizer.displayName = 'AvEqualizer';

exports.default = AvEqualizer;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/av/equalizer.js
 ** module id = 1178
 ** module chunks = 0
 **/